// 프로토타입의 POLICIES 시드와 정책 기반 파일 검증 로직
import { getExt } from './fileUtils';

export interface Policy {
  name: string;
  maxSizeMB: number;
  maxFiles: number;
  allowedExt: string[];
  blockedExt: string[];
  engines: string[];
  // 정책별 검사 옵션 (DB 컬럼 scan_timeout_s / quarantine_macro / quarantine_pdf_js) — optional 이라 validateFile 에 영향 없음
  scanTimeoutS?: number;
  quarantineMacro?: boolean;
  quarantinePdfJs?: boolean;
}

export type PolicyId = 'default' | 'strict' | 'media-only';

export const POLICIES: Record<PolicyId, Policy> = {
  default: {
    name: '기본 정책',
    maxSizeMB: 500,
    maxFiles: 10,
    allowedExt: ['.pdf', '.docx', '.xlsx', '.pptx', '.jpg', '.jpeg', '.png', '.gif', '.mp4', '.mov', '.zip', '.csv', '.txt'],
    blockedExt: ['.exe', '.bat', '.ps1', '.sh', '.vbs', '.jar', '.dll', '.msi', '.scr', '.cmd', '.hta'],
    engines: ['clamav', 'yara'],
  },
  strict: {
    name: '엄격 정책',
    maxSizeMB: 50,
    maxFiles: 1,
    allowedExt: ['.pdf', '.jpg', '.jpeg', '.png'],
    blockedExt: ['.exe', '.bat', '.ps1', '.sh', '.vbs', '.jar', '.dll', '.msi', '.scr', '.cmd', '.hta', '.zip', '.rar'],
    engines: ['clamav', 'yara', 'macro-detect'],
  },
  'media-only': {
    name: '미디어 정책',
    maxSizeMB: 2048,
    maxFiles: 5,
    allowedExt: ['.jpg', '.jpeg', '.png', '.gif', '.mp4', '.mov', '.webp'],
    blockedExt: ['.exe', '.bat', '.ps1', '.sh', '.vbs', '.jar', '.dll', '.msi', '.scr', '.cmd', '.hta'],
    engines: ['clamav'],
  },
};

export type ValidationReason = 'extension_blocked' | 'size_exceeded' | 'extension_not_allowed';

export type ValidationResult =
  | { ok: true; ext: string; sizeMB: number }
  | { ok: false; reason: ValidationReason; ext: string; sizeMB: number; detail: string };

export function validateFile(file: { name: string; size: number }, policy: Policy): ValidationResult {
  const ext = getExt(file.name);
  const sizeMB = file.size / (1024 * 1024);
  if (policy.blockedExt.includes(ext)) {
    return { ok: false, reason: 'extension_blocked', ext, sizeMB, detail: `${ext} is in blocked list` };
  }
  if (sizeMB > policy.maxSizeMB) {
    return { ok: false, reason: 'size_exceeded', ext, sizeMB, detail: `${sizeMB.toFixed(1)}MB > ${policy.maxSizeMB}MB` };
  }
  if (!policy.allowedExt.includes(ext)) {
    return { ok: false, reason: 'extension_not_allowed', ext, sizeMB, detail: `${ext} not in allow list` };
  }
  return { ok: true, ext, sizeMB };
}
